<template>
	<div class="confirmation-container" v-if="isOpen">
		<b-form @submit.prevent="confirmBooking()">
			<div class="section-header details">
				<span>{{ translation.confirmation.bookingDetails }}</span>
				<span class="material-icons-round close-button" @click="close">close</span>
			</div>
			<div class="details-content">
				<div>
					<span>{{ translation.checkin + ': ' }}<span>{{ bookingInfo.checkin }}</span></span>
					<span>{{ translation.checkout + ': ' }}<span>{{ bookingInfo.checkout }}</span></span>
				</div>
				<div>
					<span>{{ translation.confirmation.roomCategory + ': ' }}<span>{{ bookingInfo.roomType.translations.find(t => t.language.id == $store.state.language.id).name }}</span></span>
					<span class="float-right">
						<span>{{ userCurrency.symbol }}</span><span>{{ bookingInfo.price.dailyPricePerRoom }}</span>
					</span>
				</div>
				<div>
					<span>{{ translation.confirmation.meal + ': ' }}<span>{{ bookingInfo.price.mealPlan ? translation.mealPlans[bookingInfo.price.mealPlan.name.replace(' ', '')] : translation.mealPlans.noMeals }}</span></span>
				</div>
				<div>
					<span v-for="(room, i) in bookingInfo.roomsQty">{{ translation.confirmation.room }} {{ i + 1 }} - {{
						bookingInfo.adultsQty }} {{ translation.adults }} <span v-if="bookingInfo.chdAges.length > 0">{{
			bookingInfo.chdAges.length }} {{ translation.children }}</span><br></span>
				</div>
				<br>
				<span>{{ translation.confirmation.taxObs }}</span>
			</div>
			<div class="section-header total">
				<span>
					<span>Total</span>
					<span class="float-right">
						<span>{{ userCurrency.symbol }}</span>
						<span>{{ bookingInfo.price.price }}</span>
					</span>
				</span>
			</div>
			<div :id="'cancellationPolicy' + bookingInfo.price.id" class="cancellation-policy">
				<div>
					<span>{{ translation.confirmation.cancellationPolicy }}</span>
				</div>
				<span>{{ bookingInfo.cancellationPolicyText }}</span>
			</div>
			<div class="section-header client-information">
				<span>{{ translation.confirmation.clientInformation }}</span>
				<br>
				<div v-for="(room, i) in hotelBookingRequest.rooms">
					<span>{{ translation.confirmation.information(i + 1) }}</span>
					<b-row v-for="(adult, j) in room.guests" :key="j">
						<b-col cols="12">
							<b-form-group id="guestGroup" :label="translation.confirmation.guest" label-for="guest-input">
								<b-form-input id="guest-input" v-model="adult.name" size="sm" :placeholder="translation.confirmation.name" required />
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="12">
							<b-form-textarea id="textarea" rows="3" v-model="hotelBookingRequest.obs" :placeholder="translation.confirmation.observations"></b-form-textarea>
						</b-col>
					</b-row>
				</div>
			</div>
			<div :id="'generalConditions' + bookingInfo.price.id" class="section-header general-conditions" @click="generalConditionsIsHidden = !generalConditionsIsHidden">
				<span>{{ translation.confirmation.generalConditions }}</span><span v-if="!generalConditionsIsHidden" class="material-icons-round">expand_less</span>
				<div v-if="!generalConditionsIsHidden" v-html="translation.confirmation.generalConditionsDescription"></div>
			</div>
			<div class="agreement">
				<span>{{ translation.confirmation.invoiceAdvice }}</span>
				<p>
					<b-form-checkbox :name="'accept-agreement-conditions' + bookingInfo.price.id" required>
						<em>{{ translation.confirmation.generalConditionsText1 }} <a :href="'#generalConditions' + bookingInfo.price.id" @click="generalConditionsIsHidden = !generalConditionsIsHidden">{{ translation.confirmation.generalConditions }}</a></em>
					</b-form-checkbox>
					<b-form-checkbox :name="'accept-cancellation-policy' + bookingInfo.price.id" required>
						<em>{{ translation.confirmation.cancellationPolicyText1 }} <a :href="'#cancellationPolicy' + bookingInfo.price.id">{{ translation.confirmation.cancellationPolicy }}</a></em>
					</b-form-checkbox>
				</p>
			</div>
			<div style="text-align: center;">
				<b-button class="finalize-button" type="submit" :disabled="$store.state.show.loading">{{translation.confirmation.finalize}}</b-button>
			</div>
		</b-form>
	</div>
</template>
<script>
import { translate } from '../../assets/translations';
import BookingService from '../../services/BookingService';
import HotelBookingRequest from '../../model/HotelBookingRequest'

export default {
	props: ['userCurrency'],
	data() {
		return {
			bookingService: new BookingService(JSON.parse(localStorage.getItem('user'))),
			bookingInfo: {},
			hotelBookingRequest: {},
			paxRequest: {name: null},
			isOpen: false,
			generalConditionsIsHidden: true
		}
	},
	computed: {
		translation() {
			return translate(this.$store.state.language).searchArea;
		},
	},
	methods: {
		open(bookingInfo) {
			console.log(bookingInfo);
			this.bookingInfo = bookingInfo;
			this.isOpen = !this.isOpen;
			this.hotelBookingRequest = new HotelBookingRequest(bookingInfo);
		},
		close() {
			this.isOpen = false;
		},
		confirmBooking() {
			this.paxRequest.name = this.hotelBookingRequest.rooms[0].guests[0].name;
			this.bookingService.save({
				pax: this.paxRequest,
				hotelBooking: this.hotelBookingRequest,
				serviceBookings: null,
				type: 'hotel'
			})
			.then((res) => {
				this.$store.dispatch("showAlert", {
					message: "Reserva " + res.data.fileNumber + " confirmada com sucesso!",
					code: 0,
					show: true,
					style: "success"
				})
				this.hotelBookingRequest = {};
				this.isOpen = false;
				scrollTo(0,0);
			})
			.catch((err) =>
				this.$store.dispatch("showAlert", {
					message: this.translation.confirmation.errorMsg,
					code: 0,
					style: "danger"
				})
			)
		},
	},
}
</script>
<style scoped lang="scss">
.confirmation-container {
	width: 100%;
	background-color: #eeeeec;
	margin: 0px 1em;
	font-size: 1em;

	.details {
		width: 100%;

		.close-button {
			float: right;
    	cursor: pointer;
    	line-height: 2.5em;
    	font-size: 14px;
		}
	}

	.details-content {
		padding: 1em;
    line-height: 1.3em;
	}

	.total {
	}

	.cancellation-policy {
		margin: 0px 1em;
	}

	.client-information {
		padding: 1% !important;
	}

	.general-conditions {
		span {
			vertical-align: middle;
			cursor: pointer;
		}
	}

	.agreement {
		font-weight: bold;
		margin: 0px 3em;
	}

	.finalize-button {
		background-color:#163247;
		color: white;
		margin-bottom: 1em;
	}

	.section-header {
		background-color:#163247;
		color: white;
		padding: 0px 1%;
		margin: 0px 0px 1%;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/booking-confirmation/BookingConfirmation.vue